import React from 'react';

const EditLink = React.lazy(() => import('./EditLink'));
const CreateLink = React.lazy(() => import('./CreateLink'));
const DuplicateLink = React.lazy(() => import('./DuplicateLink'));
const ConfigureLinks = React.lazy(() => import('./ConfigureLinks'));

export { EditLink, CreateLink, DuplicateLink, ConfigureLinks };
